import { FormattedMessage } from "react-intl";

const AuditLogsDataResidency = () => {
    return (
        <div>
            <p>
                <FormattedMessage
                    id="JiraServiceManagementPricingPageTeam24.features.auditLogsDataResidency.content.body"
                    defaultMessage="Keep record of important events, like changes to global permissions, and choose where key product data is hosted."
                />
            </p>
        </div>
    );
};

export default AuditLogsDataResidency;
